module.exports = __webpack_public_path__ + "img/wsczzhjkyypt11.d68a6bac.png";